import script from "./ColumnCategory.vue?vue&type=script&lang=ts&setup=true"
export * from "./ColumnCategory.vue?vue&type=script&lang=ts&setup=true"

import "./ColumnCategory.vue?vue&type=style&index=0&id=62717e2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62717e2a"]])

export default __exports__